export const getFormattedDate = (value: string | null | undefined): string => {
    if (value === null || value === undefined) {
        return "";
    }
    const date = new Date(value);
  return date.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

export const getFormattedCurrency = (value: number | null | undefined): string => {
    if (value === null || value === undefined) {
        return "";
    }

    return "$" + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2});
}
